import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints, fontFamilies, fontSizes, fontWeights, lineHeights, palette,
}: Theme) => ({
  root: {
    padding: '1.5rem',
    paddingBottom: '2rem',
    textAlign: 'center',
    [breakpoints.up('md')]: {
      padding: '3rem',
    },
  },
  lensesImage: {
    display: 'flex',
    marginTop: '0.75rem',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    borderRadius: '1rem',
    background: 'linear-gradient(180deg, #eafaff 59.41%, #d8f4ff 100%)',
    [breakpoints.up('md')]: {
      height: '14.25rem',
    },
    '& img': {
      width: '10.687rem',
      height: 'auto',
      objectFit: 'contain',
    },
  },
  lensesImg: {
    display: 'block',
    width: '10.6875rem',
    height: 'auto',
    objectFit: 'contain',
  },
  title: {
    margin: '2rem 0',
    textAlign: 'start',
    fontSize: '1.25rem',
    lineHeight: 1.4,
    [breakpoints.up('md')]: {
      fontSize: '1.75rem',
    },
  },
  description: {
    margin: '2rem 0 1rem',
    color: palette.text.primary,
    fontFamily: fontFamilies.primary,
    fontSize: fontSizes.xs,
    lineHeight: lineHeights.xs,
    textAlign: 'start',
    [breakpoints.up('md')]: {
      margin: '0 0 24px',
      fontSize: fontSizes.sm,
      lineHeight: lineHeights.lg,
    },
  },
  videoTitle: {
    textAlign: 'start',
    margin: 0,
    color: palette.text.primary,
    fontSize: fontSizes.xs,
    lineHeight: 1.5,
    fontWeight: fontWeights.medium,
    [breakpoints.up('md')]: {
      fontSize: fontSizes.sm,
    },
  },
  video: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    height: 'inherit',
    marginTop: '0.5rem',
    marginBottom: '2rem',
    paddingTop: '56.25%',
    overflow: 'hidden',
    '& iframe': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      border: 0,
      objectFit:' cover',
    },
  },
  veevaNumber: {
    marginTop: '1rem',
  },
}));
